export enum RESTRICTED_ACTIONS {
  DIFF = 'diff',
  EXPORT = 'export',
  PRINT = 'print',
  RESOURCES_ACCESS = 'resources_access',
  VIEW = 'view',
  ANNOTATIONS = 'annotations',
  OBLIGATIONS = 'obligations'
}
